import { Tool } from './base';

export class SentinelOneTool extends Tool {
  public readonly toolName = 'SentinelOne';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string,
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}/dv/hunting?queryString=${encodedRenderedContent}&timeFrame=Last24Hours&isRunQuery=false`;
  }
}
